/*
 * Sticky-Warenkorb-Leiste (snippets/kik-sticky-atc.liquid).
 * Sichtbar erst, wenn man am Haupt-Button der Produktseite vorbeigescrollt ist (er liegt oberhalb des Bildes).
 * Liegt er noch unterhalb, z. B. am Handy beim Laden, bleibt die Leiste weg (Wunsch Jonathan, 12.10.2026).
 * Setzt dabei body.kik-sticky-on, damit Trusted-Shops-Badge und WhatsApp-Button nach oben ausweichen (kik-base.css).
 * Impact rendert den Liquid-Block bei jedem Variantenwechsel neu; das Element verbindet sich dann frisch.
 */
(() => {
  if (window.customElements.get('kik-sticky-atc')) return;

  class KikStickyAtc extends HTMLElement {
    connectedCallback() {
      const info = this.closest('.product-info') || document;
      this.target = info.querySelector('[data-block-type="buy-buttons"]');
      if (!this.target) return;

      // Scroll statt IntersectionObserver: auch ein Sprung nach oben (Tippen auf die Statusleiste) blendet die Leiste aus
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.target.isConnected) this.target = info.querySelector('[data-block-type="buy-buttons"]');
          if (this.target) this.toggle(this.target.getBoundingClientRect().bottom < 0);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();

      // Handy: Trusted-Shops-Badge ausblenden, solange die Produktüberschrift im Bild ist (kik-base.css)
      this.titel = info.querySelector('h1');
      if (this.titel) {
        this.titelObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => document.body.classList.toggle('kik-titel-sichtbar', entry.isIntersecting));
        });
        this.titelObserver.observe(this.titel);
      }

      this.select = this.querySelector('.kik-sticky__groesse');
      this.onChange = () => {
        const radio = document.querySelector(`input[name="${this.select.dataset.optionName}"][value="${this.select.value}"]`);
        if (radio) radio.click();
      };
      this.select?.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.titelObserver?.disconnect();
      this.select?.removeEventListener('change', this.onChange);
    }

    toggle(sichtbar) {
      document.documentElement.style.setProperty('--kik-sticky-h', `${this.offsetHeight}px`);
      this.classList.toggle('is-visible', sichtbar);
      this.toggleAttribute('inert', !sichtbar);
      document.body.classList.toggle('kik-sticky-on', sichtbar);
    }
  }

  window.customElements.define('kik-sticky-atc', KikStickyAtc);
})();
